<div class="datepicker-wrapper">
  <p>{{ label | i18next }}</p>
  <mat-form-field
    appearance="fill"
    class="datepicker"
    [ngClass]="{ error: hasError }"
  >
    <mat-label>{{ placeholder | i18next }}</mat-label>
    <input
      matInput
      [id]="id"
      [ngClass]="{ error: hasError }"
      [attr.aria-required]="isRequired"
      [attr.aria-describedby]="errorId"
      [(ngModel)]="value"
      (blur)="markAsTouched()"
      [matDatepicker]="picker"
      [min]="minDate"
      [max]="maxDate"
    />

    <mat-datepicker-toggle matSuffix [for]="picker">
      <i
        class="fa fa-chevron-down"
        matDatepickerToggleIcon
        aria-hidden="true"
      ></i>
    </mat-datepicker-toggle>
    <mat-datepicker #picker [startView]="startView"></mat-datepicker>
  </mat-form-field>
  <i class="fa fa-exclamation-triangle" *ngIf="hasError"> </i>
</div>

<div class="errorLabel" *ngIf="hasError">
  <div #injectedError>
    <ng-content></ng-content>
  </div>

  <ng-container *ngIf="!injectedError.hasChildNodes()">
    <span class="app-error-text" [id]="errorId">
      {{ errorText | i18next }}
    </span>
  </ng-container>
</div>
